import { gql } from "@apollo/client";

import { GENERAL_FIELDS, SITE_FIELDS, ARTICLE_FIELDS } from "./shared";
import { ARTICLE_TEASER_IMAGE } from "./articles";

export const REVIEWER_FIELDS = gql`
  fragment ReviewerFields on ReviewerRecord {
    __typename
    id
    name
    functionTitle
    slug
    slugs: _allSlugLocales {
      locale
      value
    }
    introduction {
      value
    }
    profilePicture {
      id
      responsiveImage(
        imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "400", h: "400", q: "75" }
      ) {
        alt
        height
        src
        title
        width
      }
    }
  }
`;

export const REVIEWER_QUERY = gql`
  ${SITE_FIELDS}
  ${GENERAL_FIELDS}
  ${REVIEWER_FIELDS}
  query GetReviewer($slug: String!, $locale: SiteLocale!) {
    site: _site(locale: $locale) {
      ...SiteFields
    }
    general(locale: $locale) {
      ...GeneralFields
    }
    fields: reviewer(filter: { slug: { eq: $slug } }, locale: $locale) {
      seoMetaTags: _seoMetaTags(locale: $locale) {
        attributes
        content
        tag
      }
      ...ReviewerFields
    }
  }
`;

export const REVIEWER_ARTICLES_QUERY = gql`
  ${ARTICLE_FIELDS}
  ${ARTICLE_TEASER_IMAGE}
  query GetReviewerArticles(
    $reviewerId: ItemId!
    $locale: SiteLocale!
    $first: IntType = 100
    $skip: IntType = 0
  ) {
    articles: allArticles(
      locale: $locale
      first: $first
      skip: $skip
      filter: { _locales: { allIn: [$locale] }, reviewer: { eq: $reviewerId } }
      orderBy: date_DESC
    ) {
      ...ArticleFields
      ...ArticleTeaserImage
    }
  }
`;

export const ALL_REVIEWER_SLUGS_QUERY = gql`
  query GetAllReviewerSlugs($locale: SiteLocale!, $first: IntType!, $skip: IntType!) {
    allReviewers(
      locale: $locale
      first: $first
      skip: $skip
      filter: { slug: { neq: null }, _locales: { anyIn: [$locale] } }
    ) {
      __typename
      id
      slugs: _allSlugLocales {
        locale
        value
      }
      seo {
        noIndex
      }
    }
  }
`;
